import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "Errors",
    component: () => require("./errors-view")
});

export default definition;
